/**
 * Admin MCP Keys API client — admin-only worklist of key-holders and a
 * manual single-key revoke. Mirrors the api/user-profile.ts conventions.
 */

import * as api from '../services/api-client';
import type { AdminMcpKeyHolder } from '@coreflow/shared';

/**
 * Fetches the admin worklist of all MCP key-holders with their live Entra
 * status and key metadata. Admin-only (403 for non-admins).
 */
export async function listMcpKeyHolders(): Promise<{ data: { users: AdminMcpKeyHolder[] } }> {
  return api.get<{ data: { users: AdminMcpKeyHolder[] } }>('/v1/admin/mcp-keys');
}

/**
 * Revokes a single MCP key for the given target user. Admin-only.
 * Immediately disables the key by deleting both key records server-side.
 */
export async function adminRevokeMcpKey(userId: string, keyId: string): Promise<void> {
  await api.del(`/v1/admin/users/${encodeURIComponent(userId)}/mcp-keys/${encodeURIComponent(keyId)}`);
}
